import { render, staticRenderFns } from "./ViqInputArea.vue?vue&type=template&id=18a57ba5&scoped=true"
import script from "./ViqInputArea.vue?vue&type=script&lang=js"
export * from "./ViqInputArea.vue?vue&type=script&lang=js"
import style0 from "./ViqInputArea.vue?vue&type=style&index=0&id=18a57ba5&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a57ba5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18a57ba5')) {
      api.createRecord('18a57ba5', component.options)
    } else {
      api.reload('18a57ba5', component.options)
    }
    module.hot.accept("./ViqInputArea.vue?vue&type=template&id=18a57ba5&scoped=true", function () {
      api.rerender('18a57ba5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/viq/ViqInputArea.vue"
export default component.exports